import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";
import DashboardRightSection from "../../Components/DashboardRightSection/DashboardRightSection";
import ChangePassword from "../../Components/ChangePassword/ChangePassword";

function ChangePasswordPage() {
    return (
        <div className="BallotsPage">
            <div className="ballotsPageContainer">
                <div className="headerContain">
                    <Header />
                </div>
                <div className="ballotsPageContainer2">
                    <div className="sidebarContain">
                        <Sidebar />
                    </div>
                    <div className="middleContainer">
                        <ChangePassword />
                    </div>
                    <div className="dashboardRightSectionContain">
                        <DashboardRightSection />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ChangePasswordPage;